import { SettingsIntegrations } from './settings/settings-integrations';

export function SettingsIntegrationsPage() {
  return (
    <div className="h-full overflow-y-auto">
      <SettingsIntegrations />
    </div>
  );
}

export default SettingsIntegrationsPage;
